import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_BASE_URL } from "../../data/agenticSeoUtils";

const DEFAULT_OG_IMAGE = `${SITE_BASE_URL}/logo.png`;

export default function DomainSeoHelmet({
  intro,
  domainSlug,
  useCaseCount,
  groupCount,
  itemListJsonLd,
  faqJsonLd,
  breadcrumbJsonLd,
  webPageJsonLd,
  keywords,
  ogImage,
  sectionLabel = "",
  basePath = "/agentic-ai",
  llmFullPath,
}) {
  const isRpa = basePath.includes("rpa");
  const fullCatalogPath = llmFullPath || (isRpa ? "/llms-rpa.txt" : "/llms-full.txt");
  const metaTitle = sectionLabel
    ? `${intro.title} ${sectionLabel} | SurensInffotek`
    : `${intro.title} | SurensInffotek`;
  const canonicalUrl = `${SITE_BASE_URL}${basePath}/${domainSlug}`;
  const image = ogImage || DEFAULT_OG_IMAGE;
  const metaKeywords =
    keywords ||
    `${intro.title.toLowerCase()} ${isRpa ? "RPA, document AI + RPA, workflow automation" : "agentic AI, workflow automation, AI agents"}, ${intro.seoDescription}`;
  const abstract =
    useCaseCount != null && groupCount != null
      ? `${useCaseCount} ${isRpa ? "RPA" : "agentic AI"} use cases across ${groupCount} categories in ${intro.title}. ${intro.seoDescription}`
      : intro.seoDescription;
  const ogImageAlt = `${intro.title} ${isRpa ? "RPA" : "agentic AI"} use cases`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{metaTitle}</title>
      <meta name="description" content={intro.seoDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="author" content="SurensInffotek" />
      <meta name="abstract" content={abstract} />
      <link rel="canonical" href={canonicalUrl} />
      <link rel="alternate" type="text/plain" title="LLM summary" href={`${SITE_BASE_URL}/llms.txt`} />
      <link rel="alternate" type="text/plain" title="LLM full catalog" href={`${SITE_BASE_URL}${fullCatalogPath}`} />
      <link rel="alternate" type="text/plain" title="LLM agentic catalog" href={`${SITE_BASE_URL}/llms-full.txt`} />
      <link rel="alternate" type="text/plain" title="LLM RPA catalog" href={`${SITE_BASE_URL}/llms-rpa.txt`} />

      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={intro.seoDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="SurensInffotek" />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={ogImageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={intro.seoDescription} />
      <meta name="twitter:image" content={image} />

      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(itemListJsonLd)}</script>
      {faqJsonLd ? (
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      ) : null}
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
    </Helmet>
  );
}

